import React, { PropsWithChildren, useContext } from 'react';
import { TModalProps } from './types';
import cx from 'classnames';
import { useTheme } from 'styled-components';
import { AppContext } from 'src/App';
import { StyledModalBody, StyledModalHeading, StyledReactModal } from './style';

export default function Modal({
  children,
  type = 'default',
  title,
  className,
  ...props
}: PropsWithChildren<TModalProps>) {
  const theme = useTheme();
  const { modal } = useContext(AppContext);

  const customStyles: TModalProps['style'] = {
    content: {
      margin: '30vh auto 0',
      width: '100%',
      maxWidth: '50vw',
      minWidth: '320px',
      backgroundColor: theme.colors.white,
      color: theme.colors.dark,
      borderRadius: theme.borderRadius.base,
      border: `1px solid ${theme.borderRadius.base}`,
    },
    overlay: {
      backgroundColor: 'rgb(52,58,64,0.3)',
      zIndex: 9000,
    },
  };

  return (
    <StyledReactModal {...props} style={customStyles} className={cx(className, 'modal', `modal_${type}`)}>
      <StyledModalHeading>
        {title && <h2>{title}</h2>}
        {type !== 'success' && <button onClick={modal.closeModal}>x</button>}
      </StyledModalHeading>
      <StyledModalBody>{children}</StyledModalBody>
    </StyledReactModal>
  );
}
